import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export const createRecurringOrderByInstanceWeek = ({
  recurringOrderId,
  instanceWeek,
}: {
  recurringOrderId: string | number;
  /**
   * ISO string
   */
  instanceWeek: string;
}): AxiosPromise => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/recurring-orders/${recurringOrderId}/order`,
    data: {
      instanceWeek,
    },
  });
};
